import clientAxios from "../../client";
import type { QueryType } from "@/common/types/common";
import { formatQueryString } from "@/common/utils/common";

export async function nameList(owner_id: string, query?: QueryType) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `admin/game/${owner_id}/name/list${queryString}`,
  );
}

export async function nameGet(item_id: string) {
  return await clientAxios.get(`admin/game/name/${item_id}/show`);
}

export async function nameCreate(owner_id: string) {
  return await clientAxios.post(`admin/game/${owner_id}/name/create`, {});
}

export async function namePatch(item_id: string, payload: { name: string }) {
  return await clientAxios.patch(`admin/game/name/${item_id}/patch`, {
    payload,
  });
}

export async function nameDel(item_id: string) {
  return await clientAxios.del(`admin/game/name/${item_id}/delete`);
}
